(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["handmen-collection-filter-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    const form = input.closest('.handmen-filter-bar__form');
    if (!form) return;
    if (input.type === 'checkbox') form.submit();
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.handmen-filter-link');
    if (link) {
      event.preventDefault();
      const param = link.getAttribute('data-filter-param');
      const value = link.getAttribute('data-filter-value');
      if (!param || !value) return;
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (url.searchParams.getAll(param).includes(value)) url.searchParams.delete(param, value);
      else url.searchParams.append(param, value);
      window.location.href = url.toString();
      return;
    }
    document.querySelectorAll('.handmen-filter-menu[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
  });
  document.addEventListener('DOMContentLoaded', () => {
    const params = new URL(window.location.href).searchParams;
    document.querySelectorAll('.handmen-filter-link').forEach((link) => {
      if (!(link instanceof HTMLElement)) return;
      const param = link.getAttribute('data-filter-param');
      const value = link.getAttribute('data-filter-value');
      if (!param || !value) return;
      if (params.getAll(param).includes(value)) {
        link.classList.add('is-active');
        const summary = link.closest('.handmen-filter-menu')?.querySelector('summary');
        if (summary && !summary.querySelector('em')) {
          const badge = document.createElement('em');
          badge.textContent = String(params.getAll(param).length);
          summary.appendChild(badge);
        }
      }
    });
    const moneyToNumber = (value) => {
      const match = String(value || '').replace(/,/g, '').match(/\$?\s*(\d+(?:\.\d{1,2})?)/);
      return match ? Number(match[1]) : 0;
    };
    const addDiscountBadges = () => {
      document.querySelectorAll('.product-card').forEach((card) => {
        if (!(card instanceof HTMLElement)) return;
        if (card.querySelector('.handmen-save-badge')) return;
        const text = card.innerText || '';
        const saleMatch = text.match(/Sale price\s*\$?\s*([\d,.]+)/i);
        const regularMatch = text.match(/Regular price\s*\$?\s*([\d,.]+)/i);
        const salePrice = moneyToNumber(saleMatch && saleMatch[1]);
        const regularPrice = moneyToNumber(regularMatch && regularMatch[1]);
        if (!salePrice || !regularPrice || regularPrice <= salePrice) return;
        const discount = Math.round(((regularPrice - salePrice) / regularPrice) * 100);
        if (discount < 5) return;
        const gallery = card.querySelector('.card-gallery');
        if (!(gallery instanceof HTMLElement)) return;
        const badge = document.createElement('span');
        badge.className = 'handmen-save-badge';
        badge.textContent = `Save ${discount}%`;
        gallery.appendChild(badge);
      });
    };
    addDiscountBadges();
    const grid = document.querySelector('[id*="product-grid"], .product-grid, main');
    if (grid) {
      const observer = new MutationObserver(addDiscountBadges);
      observer.observe(grid, { childList: true, subtree: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
